// extracted by mini-css-extract-plugin
export var blogQuoteStyling = "QuoteSection-module--blogQuoteStyling--f5918";
export var contentColor = "QuoteSection-module--contentColor--8c0f0";
export var contentContainer = "QuoteSection-module--contentContainer--7ebc8";
export var contentStyling = "QuoteSection-module--contentStyling--dca48";
export var ctaContainer = "QuoteSection-module--ctaContainer--80ace";
export var headercontainer = "QuoteSection-module--headercontainer--95d35";
export var headersContainer = "QuoteSection-module--headersContainer--e6592";
export var quoteContainer = "QuoteSection-module--quoteContainer--ebe89";
export var rowContainer = "QuoteSection-module--rowContainer--6c2f2";
export var withContent = "QuoteSection-module--withContent--69183";